import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import NumberField from '@/components/forms/new/formikFormFields/NumberField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const MinUserCount = ({ darkMode, errors }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = usePartnerForm();

    const handleChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.MIN_USER_COUNT, e.target.value);
    };
    
    const hasError = !!errors?.minBillableUsers;
    
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} align="center" sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode, true)} mb={0}>
                    Minimum User Count
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NumberField}
                        id={FORM_FIELD_PATHS.MIN_USER_COUNT}
                        name={FORM_FIELD_PATHS.MIN_USER_COUNT}
                        noPadding
                        value={formData?.partnerBillingSettings?.minBillableUsers}
                        onChange={handleChange}
                        placeholder="Minimum user count"
                        width="110%"
                        darkMode={darkMode}
                        type="number"
                        min={0}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Minimum number of users to bill for"
                        ariaLabel="min-user-count-tip"
                        left="25px"
                        top="5px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default MinUserCount;
